<template>
    <div>
        <div class="columns" id="Haut">
            <haut @goTo="arianeGo"></haut>
        </div>

        <div class="columns is-gapless" id="Contenu">

            <div class="column is-2" id="Gauche">
                <gauche></gauche>
            </div>

            <div class="column" ref="parentCol">
                <div ref="graph">
                    <div id="zoom">
                        <zoom-barre ></zoom-barre>
                    </div>

                    <v-stage  ref="stage"
                              :key="currentSituation.parent"
                              :config="stageSize"
                              @dblclick="handleClick"
                              @wheel.exact="zoom"
                              v-if="isLoaded"
                              style="background-color: white;">

                        <v-layer ref="linkLayer" name="linkLayer">
                            <lien v-for="thing in storeLinks" :linkObj="thing" :key="thing.data.ref"></lien>
                        </v-layer>

                        <v-layer ref="layer" name="Layer">
                            <tache  v-for="(thing,index) in storeGetTaskList"
                                   v-bind:obj="thing"
                                   :key="thing.id"
                                    @goDeeper="goDeeper"
                                   @reload="load"
                            ></tache>
                        </v-layer>

                        <v-layer ref="dragLayer" name="DragLayer" ></v-layer>

                    </v-stage>
                </div>
            </div>

            <div class="column" id="Droite" @reload="load">
                <droite></droite>
            </div>
        </div>

    </div>
</template>



<script>
    import ZoomBarre from './ZoomBarre.vue';
    import Tache from './Tache.vue';
    import Lien from './Lien.vue';
    import Gauche from './Gauche.vue';
    import Droite from './Droite.vue';
    import Haut from './Haut.vue';

    import ResultatClass from '../classes/Resultat';
    import TacheClass from '../classes/Tache';
    import CaracClass from '../classes/Carac';

    export default {

        name: 'Home',
        data() {
            return {
                list: [],
                isLoaded:false, //flag pour tester les problemes async,
                isDragging:false,

                shiftKey:false,

            };
        },
        computed :{
            storeGetTaskList(){
                return this.$store.getters.getTaskList
            },

            storeLinks() {
                return this.$store.getters.storeLinks
            },

            stageSize() {
                const temp={
                    width:this.$refs.graph.clientWidth,
                    height:window.innerHeight-160,
                    draggable: true,
                    scale:{
                        x:this.$store.getters.getScale,
                        y:this.$store.getters.getScale
                    }
                }
                return temp
            },

            currentSituation(){
                return this.$store.getters.isSituation
            }  ,

        },
        components:{
            Tache,
            Lien,
            Gauche,
            Droite,
            Haut,
            ZoomBarre
        },
        methods: {

            //Double clic pour creer
            handleClick(evt) {
                const stage = evt.target.getStage();
                const pos = stage.getPointerPosition();

                pos.x=(pos.x-stage.x())/stage.scaleX();
                pos.y=(pos.y-stage.y())/stage.scaleX();

                this.createTask(pos)
            },


            async createTask(pos)
            {
                //creation d'un element par defaut
                let nb=1
                if(this.storeGetTaskList)
                    nb=this.storeGetTaskList.length+1
                let levelName=this.currentSituation.level+1
                if(levelName>5)
                    levelName=5
                let nom=this.$store.getters.getLevelName[levelName]+' #'+nb
                let myTask=new TacheClass(nom,this.currentSituation.level,this.currentSituation.parent,'TASK',pos)

                //creation d'une sortie par defaut
                let myRes=new ResultatClass(myTask.id,true)
                myRes.data.label=myRes.data.label+' #1'

                //creation d'une condition de sortie par defaut (la tache est effectuée)
                let myCarac=new CaracClass('META',myRes.id,myTask.id+'.done',true)
                 myRes.data.meta.push(myCarac.clef)

                //Sauvegarde tout et recharge
                await this.$mydb.do.saveTask(myTask);
                await this.$mydb.do.saveResultat(myRes);
                await this.$mydb.do.saveCarac(myCarac);
                await this.load()
                const toEdit={
                    name:'TabTache',
                    config:this.storeGetTaskList[nb-1]
                }
                this.$store.commit('DROITE_SET',toEdit);
                this.$store.commit('SET_FOCUS',{level:myTask.level,parent:myTask.id,label:myTask.data.label})

                return true
            },

            zoom (event) {

                event.evt.preventDefault();
                const stage=event.target.getStage()
                const oldScale = stage.scaleX();
                let newScale=0

                const mousePointTo = {
                    x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
                    y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale
                };

                if(event.evt.deltaY>0){
                    newScale=oldScale-0.1;
                    this.$store.commit('SCALE_CHANGE',-0.1);
                }
                else{
                    newScale=oldScale+0.1;
                    this.$store.commit('SCALE_CHANGE',0.1);
                }

                const newPos = {
                    x:
                        -(mousePointTo.x - stage.getPointerPosition().x / newScale) *
                        newScale,
                    y:
                        -(mousePointTo.y - stage.getPointerPosition().y / newScale) *
                        newScale
                };

                stage.position(newPos);

                //console.log(newScale)

                //CHANGEMENT DE CHARTE
                if(newScale<=0.5)
                    this.$store.commit('SET_MOVING',true)
                else
                    this.$store.commit('SET_MOVING',false)

                //CHANGEMENT DE NIVEAU !!!!!
                if(this.$store.getters.isFocusOn!=='' && newScale>=1.3 && newScale>oldScale){
                    //CHANGEMENT DE NIVEAU !!!!!
                    this.changeNiveau(this.$store.getters.isFocusOn)

                    //.getStage().container().style.cursor = 'default';
                    this.$store.commit('SET_FOCUS','')
                }

                if(this.shiftKey && newScale<oldScale && newScale<0.3){
                    this.chargeNiveau(this.$store.getters.isComingFrom)
                }

            },

            async changeNiveau(cible)
            {
                //check si le niveau existe déjà ?
                //qui ?
                cible.level++
                const tmp=await this.$mydb.do.countChildrenOf(cible.level,cible.parent)


                if(tmp>0){
                    this.chargeNiveau(cible)
                }
                else{
                    this.chargeNiveau(cible)
                    /*
                    /POPUP D'AVERTISSEMENT - décommenter ce bloc et commenter la ligne précédente
                    let levelName=this.$store.getters.getLevelName[cible.level+1]
                    if(cible.level>=4)
                        levelName=this.$store.getters.getLevelName[5]
                    this.$dialog.confirm({
                        title: 'NOUVEAU NIVEAU',
                        message: 'Ce niveau n\'existe pas encore. Vous allez arriver sur une page blanche où vous pourrez créer des '+levelName+'S !',
                        confirmText: 'OK',
                        type: 'is-danger',
                        hasIcon: true,
                        onConfirm: () => this.chargeNiveau(cible)
                    })
                    */
                }
            },

            goDeeper(){
                //CHANGEMENT DE NIVEAU !!!!!
                this.changeNiveau(this.$store.getters.isFocusOn)

                //.getStage().container().style.cursor = 'default';
                this.$store.commit('SET_FOCUS','')
            },

            chargeNiveau(cible){

                this.$store.commit('SET_SITUATION', cible)
                this.$store.commit('SCALE_SET', 0.5)
                this.$store.commit('CLEARLINK')
                this.isLoaded = false
                this.load()
                //switch sidebar
                const toEdit={
                    name:'TabHelp',
                    config:''
                }
                this.$store.commit('DROITE_SET',toEdit);
            },


            async load() {
                //await this.$store.dispatch('load')
                //this.isLoaded=false;

                await this.$store.dispatch('loadOf',this.currentSituation)
                this.isLoaded=true;

                return true;
            },

            async save() {
                for (const mytask of this.list) {
                    await this.$mydb.do.saveTask(mytask)
                }
                return true;
            },

            async onResize() {

                //Super trick pour permettre le resize ....
                const theStage=this.$refs.stage.getStage()
                theStage.visible(false)
                const newsize=await this.$refs.graph.offsetWidth;
                theStage.width(newsize)
                theStage.visible(true)
                theStage.draw()
            },

            shiftOn(evt){
                this.shiftKey=true
            },
            shiftOff(evt){
                this.shiftKey=false
            },

            async arianeGo(evt){
                this.chargeNiveau(evt)
                //console.log(evt)
            },


        },

        mounted(){
            this.load();
            window.addEventListener('resize', this.onResize)

            window.addEventListener('keydown', this.shiftOn)

            window.addEventListener('keyup', this.shiftOff)
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize)
        }
    };
</script>


<style lang="scss">



    h2{
        color:$primary;
        font-size:1.2em;
    }

    #Contenu{
        width:100%;
        height:auto;
    }

    #Gauche{
        width:200px;
        background-color: $grey-light;
        padding-left:5px !important;
    }

    #Haut{
        height:120px;
        background-color: #4099FF;
        margin-bottom:0px !important;
        padding : 10px !important;
    }

    #graph{
        overflow: auto;
    }

    #zoom{
        text-align: right;
        width:100%;
        height:auto;
        z-index:99999;
    }

    #Droite{
        flex: 0 0 350px !important;
        background-color: $grey-light;
        padding-right:0px;
        height:auto;
    }

</style>
